import { navSectionCountVariants, navSectionLabelVariants } from '@/shared/config/sidebar';
import { Trans } from '@lingui/react/macro';
import type { ReactNode } from 'react';

/** Section header row for a sidebar list, with an optional `count of total` badge. */
export const NavSectionLabel = ({
  children,
  count,
  total,
  size = 'compact',
}: {
  children: ReactNode;
  count?: number;
  total?: number;
  /** `comfortable` — larger label for the mobile full-screen menu. */
  size?: 'compact' | 'comfortable';
}) => (
  <div className="flex items-center justify-between px-1">
    <p className={navSectionLabelVariants({ size })}>{children}</p>
    {count !== undefined && (
      <span className={navSectionCountVariants({ size })}>
        {total !== undefined && count !== total ? (
          <Trans>
            {count} of {total}
          </Trans>
        ) : (
          count
        )}
      </span>
    )}
  </div>
);
